import pixAxios from '@/axios/pixAxios';

const addUserAccess = async (params) => {
  const response = await pixAxios.post('api/WebAnalytics/AddUserAccess', params);
  return response;
};

const getUserAccess = async (params) => {
  const response = await pixAxios.get('api/WebAnalytics/GetUserAccess', { params });
  return response;
};

const saveLog = async (params) => {
  const response = await pixAxios.post('api/WebAnalytics/SaveLog', params);
  return response;
};

export default {
  addUserAccess,
  getUserAccess,
  saveLog,
};
